import { Trans, useTranslation } from "@equiem/web-ng-lib";
import { Site } from "@equiem/web-ng-lib";
import { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Envelope } from "../icons/Envelope";
import { RoundButton } from "../RoundButton";

interface Props {
  label: string;
}

export const RsvpButton: React.FC<Props> = ({ label }) => {
  const { t } = useTranslation();

  const [showRegisterNow, setShowRegisterNow] = useState(false);
  const { name: siteName } = useContext(Site);

  return (
    <>
      <RoundButton
        className="btn-rsvp ml-2 mb-2 disabled"
        shadow="always"
        label={label}
        loading={false}
        value={false}
        onToggle={async () => {
          setShowRegisterNow(true);
        }}
      >
        <Envelope size={22} />
      </RoundButton>
      <Modal
        show={showRegisterNow}
        onHide={() => {
          setShowRegisterNow(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("main.eventRsvp")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Trans i18nKey="main.partOfCommunityRsvpForEventRegisterNow" values={{ siteName }} components={[<></>, <></>, <></>, <a href="/api/login?screen_hint=signup&utm_medium=sc" />]} />
        </Modal.Body>
      </Modal>
    </>
  );
};
